import React from 'react';
import {useState, useContext, /* useMemo,*/ useCallback} from 'react';
import "./testef.css";
import {Error} from '../../components/Erro';
import Loading from '../Loading';

import api from '../../services/api';
import {UserContext} from '../../hooks/UserContext'
import {useFetch} from '../../hooks/useFetch'
// import useFind from '../../hooks/useFind'

const states = { // estados possiveis
    INIT:'INIT',
    START:'START',
    PRE_START:'PRE_START',
    LOADING:'LOADING',
    RESULTS:'RESULTS',
    ERROR:'ERROR',
    JAFEZ:'JAFEZ',
    ERRO:'ERRO',
    RESULTSBL:'RESULTSBL',
}

function TesteFinal(props){
    const {teste_data} = props;
    const teste_final_id = teste_data.id;
    const quiz_data = teste_data.quiz;
    // const quiz_id = quiz_data.id;
    // const quiz_id = teste_data.quiz_id;

    const [state, setState] = useState(states.INIT)
    const { user } = useContext(UserContext);
    const user_id = user?.id;

    const [telaCheia, setTelaCheia]     = useState(false);
    const [error, setError]             = useState();//{messages:"eita"}
    const [pergunta, setPergunta]       = useState({});
    const [n_pergunta, setN_pergunta]   = useState(1);
    const [msg, setMsg]                 = useState();
    const [acertos, setAcertos]         = useState([]);

    const [nTentativas, setNTentativas] = useState(0);
    const [user_teste, setUserTeste]    = useState(undefined);


    if (!user_id){
        setMsg('Faça o login novamente')
        setError('Usuario não conectado')
        setState('INIT')
    }

    const carregar = useCallback(
        async () => {
           const data = await apiTesteStart({teste_final_id, n_pergunta})
           if (!!data.success && !!data.pergunta){
                // await setState('LOADING')
                await setPergunta(data.pergunta)
            } else {
                await setError(data)
                if (!!data.pergunta){
                    await setError({mensagens:'Erro de conexão, tente novamente mais tarde'})
                }
                await setState(states.ERRO);
            }
        },
        [teste_final_id,n_pergunta],
    )

    const calcularTentativas = useCallback(
        async () => {
            const data = await apiGet(`/user/testesf/${teste_final_id}`);
            console.log("data",data)
            if (!!data.sucess){
                console.error(data);
                setState(states.ERRO)
            }
            setNTentativas(data.user_teste.length);
            setUserTeste(data.user_teste);
            if (data.user_teste.length>=1){
                setState(states.RESULTSBL);
            }
            // console.log('quiz_id',quiz_id)
            // if (data.user_teste.some(x=>x.id===quiz_id)){
            //     console.log('ja fez teste')
            //     setState(states.JAFEZ);
            //     setJaFez(true);
            // }
        },
        [teste_final_id],
        //[user_id,quiz_id],
        // [user_id],
    )

    if(state === states.ERRO){
        console.error(error.messages);
        console.log("Mensagemm",msg);
        return (
        <div id="testef" className={!!telaCheia ? 'quiz quiz-pop' : 'quiz quiz-pre-start'} style={{'backgroundColor':'var(--bg-testef)'}}>

            <div className="Error"> {!!error && <Error error={error.messages}/>} </div>
            {!!msg && <div className="msg">
                <div style={{"height": "1.4rem"}}/>
                {`Mensagem: ${msg}`}
                <div style={{"height": "1.4rem"}}/>
            </div>}
            <div className = "quiz-conteiner" >
                <div className={`quiz-info`} style={{'backgroundColor':'var(--cor_bloco-testef)'}}>
                    <h1>OPS, parece que algo não está certo com a conexão com os satélites do Maratoninha Maker,</h1>
                    <div style={{"height": "1.4rem"}}/>
                    <p>Nossos astronautas já foram notificados e estão trabalhando para resolver isso logo.</p>
                    <p>Tente atualizar a página e se o erro persistir tente novamente mais tarde.</p>
                </div>
            </div>
        </div>)
    } else {
        /*Teste se ja fez o quiz antes*/
        if(state === states.INIT && !user_teste){
            calcularTentativas()
        }

        /*Se é pra carregar as perguntas...*/
        if(state === states.PRE_START){
            async function salvardados(){
                let total_acertos = 0;
                acertos.forEach(a =>{
                    if (a==="✔"){
                        total_acertos=total_acertos+1
                    }
                })
                await apiTesteStartAddu({user_id,teste_final_id,tentativas:nTentativas+1,n_acertos:total_acertos})
            }
            (async () => {
                await setState(states.LOADING)
                await carregar()
                setTimeout(() => {
                    setMsg(n_pergunta===quiz_data.n_perguntas-1? 'Última pergunta!':'');
                    if (n_pergunta>=quiz_data.n_perguntas){
                        setTelaCheia(false);
                        salvardados();
                        setMsg(undefined)
                        return setState(states.RESULTS)
                    }
                    setState(states.START)
                }, 1500);

            })()
        }

        return (
            <div id="testef" className={!!telaCheia ? 'quiz quiz-pop' : 'quiz quiz-pre-start'} style={{'backgroundColor':'var(--bg-testef)'}}>
                <div>
                    <i className={`maxmin ${!!telaCheia ? "fi-rr-compress-alt" : "fi-rr-expand"}`} title="clique aqui para mudar o tamanho da tela" onClick={()=>setTelaCheia(t=>!t)}/>
                    <div className="Error"> {!!error && <Error error={error.messages}/>} </div>
                    {!!acertos?.length>0 && <div className="acertos"> Acertos {acertos.join('\t')}</div>}
                    {!!msg && <div className="msg">{`Mensagem: ${msg}`}</div>}
                </div>

                <div className =''>
                    {/* { state  === states.JAFEZ   && <JaFez setState={setState} setTelaCheia={setTelaCheia} quiz_data={quiz_data}/>} */}

                    { state  === states.INIT    && <PreStart setState={setState} setTelaCheia={setTelaCheia} quiz_data={quiz_data} nTentativas={nTentativas}/> }

                    { state  === states.LOADING && <BLoading/> }

                    { state  === states.START   && <Pergunta
                        setState={setState} pergunta={pergunta}
                        n_pergunta={n_pergunta} setN_pergunta={setN_pergunta}
                        setAcertos={setAcertos}
                        setMsg={setMsg}
                        //carregarPerguntas={carregarPerguntas}
                    /> }

                    { state  === states.RESULTS && <Results
                        user_id={user_id} teste_final_id={teste_final_id} acertos={acertos} pontos_pergunta={quiz_data.pontos}
                        total_perguntas={10} tentativas={nTentativas} total_tentativas={2} calcularTentativas={calcularTentativas}
                    /> }

                    { state  === states.RESULTSBL && <ResultsBl acertos={acertos} user_teste={user_teste} setState={setState} teste_final_id={teste_final_id}/> }
                </div>
            </div>
        );
    }



//**********************************************************

}

export default TesteFinal;




function Results({user_id,teste_final_id,acertos,pontos_pergunta,total_perguntas,tentativas,total_tentativas,calcularTentativas}){

    let total_acertos = 0;
    acertos.forEach(a =>{
        if (a==="✔"){
            total_acertos=total_acertos+1
        }
    })

    // inserindo no banco de dados as infos
    //apiTesteStartAddu({user_id,teste_final_id,tentativas:tentativas+1,n_acertos:total_acertos})

    return (
        <div className = "quiz-conteiner" >
            <div className="resultado">
                <div>
                    <h1>Resumo:</h1>
                    {console.log(acertos)}
                    <div className="respostas" style={{"paddingLeft":"40px"}}>
                        {
                            acertos.map((alternativa, i) => (<div className='resposta' key={alternativa.key}>
                                {/* {alternativa.texto} */}
                                {`${i + 1}º : ${alternativa}`}
                            </div>))
                        }
                    </div>
                </div>
                <div className={`quiz-info`} style={{'backgroundColor':'var(--cor_bloco-testef)'}}>
                    <div style={{"height": "10px"}}/>
                    <h1>{`Estes são os dados do Teste de Conhecimentos`}</h1>
                    <p>{`* Taxa de acerto: ${parseFloat(total_acertos/total_perguntas*100).toFixed(2)}%`}</p>
                    <p>{`* Você acertou: ${total_acertos} pergunta${total_acertos>1?'s':''} de 10`}</p>

                    <p>{`Clique no botão abaixo, escrito "Mais Informações"`}</p>
                </div>
            </div>
            <div className='tentar_novamente'>
                <button className='btn djbtn teste-btn' onClick={()=>calcularTentativas()}>
                    <p className="btn djbtn">Mais Informações</p>
                </button>
            </div>
        </div>
    )
}
function ResultsBl({user_teste,setState,teste_final_id}){
    const total_tentativas = 2;
    // const [certificado,setCertificado] = useState();
    const tentativas = user_teste.length
    // const total_acertos = user_teste[0].n_acertos
    const total_perguntas = 10;
    let max_acertos = 0;
    let max_data=0;

    function BlocoTentativas({indice,total_acertos,tentativas,total_perguntas,total_tentativas,data_que_fez}){

        return (
            <div className={`quiz-info`} style={{'backgroundColor':'var(--cor_bloco-testef)'}}>
                <div style={{"paddingLeft": "2.4rem"}}>
                    <div style={{"height": "2.4rem"}}/>
                    <h1>{`Sobre a ${indice+1}ª Tentativa `}</h1>
                    <div style={{"height": "2.4rem"}}/>
                    <p>{`Você acertou: ${total_acertos} pergunta${total_acertos>1?'s':''} de 10`}</p>
                    <p>{`Taxa de acerto: ${parseFloat(total_acertos/total_perguntas*100).toFixed(0)}%`}</p>
                    <p>{`O teste feito na data: ${data_que_fez}`}</p>
                </div>
            </div>
        );
    }

    const tentativas_infos = user_teste.map((data,indice)=>{
        const total_acertos = data.n_acertos
        const data_que_fez = new Date(data.createdAt)//.toLocaleString()
        if (max_acertos<total_acertos){
            max_acertos=total_acertos;
        }
        if (max_data<data_que_fez){
            max_data=data_que_fez;
        }
        return <BlocoTentativas
            key={`tentativa_${indice}`}
            indice={indice}
            total_acertos={total_acertos}
            tentativas={tentativas}
            total_perguntas={total_perguntas}
            total_tentativas={total_tentativas}
            data_que_fez={data_que_fez.toLocaleString()}
        />
    })
    const hoje = new Date();

    let quiz_info_header = <></>

    // const total_acertos=2
    if (max_acertos>=7){
        const dia_entrega = (new Date(max_data))
        dia_entrega.setDate(max_data.getDate()+1);
        // console.log("hoje ",hoje )
        // console.log("dia_entrega",dia_entrega)
        // console.log("dia_entrega-hoje",dia_entrega-hoje)
        // console.log("hoje-dia_entrega",hoje-dia_entrega)
        // console.log("hoje>dia_entrega",hoje>dia_entrega)
        // console.log("hoje<dia_entrega",hoje<dia_entrega)
        // const certificado = apiTesteGetCertificado({teste_final_id});//url

        const dia_entrega_date = (hoje>dia_entrega) ? 0 : new Date((dia_entrega-hoje)).getDate();
        // const dia_entrega_date = new Date((dia_entrega-hoje)>0?dia_entrega-hoje:hoje-dia_entrega).getDate();
        console.log(dia_entrega_date,new Date((dia_entrega-hoje)).getDate())
        const data_certificado = (<div className={`quiz-info`} style={{'backgroundColor':'var(--cor_bloco-testef)'}}>
            <p>{`     O teu certificado está sendo gerado!`}</p>
            <p>{`E vai fica disponivel para baixar assim que estiver pronto.`}</p>
            <p>{`O prazo de entrega é até o dia: ${dia_entrega.toLocaleString()}, ou seja, daqui a ~ ${dia_entrega_date} dia${dia_entrega_date>1?'s':''}`}</p>
            <BtnCertificado teste_final_id={teste_final_id}/>
        </div>)
        quiz_info_header=(
            <div className={`quiz-info`} style={{'backgroundColor':'var(--cor_bloco-testef)'}}>
                <div>
                    <h1>{`Você já fez o teste de conhecimentos antes`}</h1>
                    <div style={{"height": "10px"}}/>
                    <h1>{`e alcançou 70% ou mais de acertos. Meus Parabéns!`}</h1>
                    {data_certificado}
                </div>
            </div>
        )

    } else if (tentativas>=total_tentativas){
        quiz_info_header=(
        <div className={`quiz-info`} style={{'backgroundColor':'var(--cor_bloco-testef)'}}>
            <div>
                <h1>{`Você já fez o teste de conhecimentos antes`}</h1>
                <div style={{"height": "10px"}}/>
                    <p>{`e não conseguiu pontos o suficiente para a certificação,`}</p>
                    <p>{`mas não se preocupe, você ainda pode avançar para o próximo planeta`}</p>
                <div className={`quiz-info`} style={{'backgroundColor':'var(--cor_bloco-testef)'}}>
                    <p>{`     Mas antes de ir, te recomendo revisar os Vídeos e/ou E-books desta Missão`}</p>
                    <h1>{`bons estudos!`}</h1>
                </div>
            </div>
        </div>)
    } else {
        const dia_novo_teste = new Date(max_data)
            dia_novo_teste.setDate(dia_novo_teste.getDate()+1)
        quiz_info_header=(
        <div className={`quiz-info`} style={{'backgroundColor':'var(--cor_bloco-testef)'}}>
            <div>
                <h1>{`Você já fez o teste de conhecimentos antes`}</h1>
                <div style={{"height": "10px"}}/>
                <p>{`e não conseguiu pontos o suficiente para a certificação,`}</p>
                <div className={`quiz-info`} style={{'backgroundColor':'var(--cor_bloco-testef)'}}>
                    <p>{`     mas não se preocupe, você ainda pode tentar novamente`}</p>
                    {(dia_novo_teste-hoje)>0 &&(<>
                        <p>{`apartir de ${dia_novo_teste.toLocaleString()}`}</p>
                        <p>{`     Aproveite esse tempo para revisar os Vídeos e/ou E-books`}</p>
                    </>)}
                    {(dia_novo_teste-hoje)<=0 &&(<div className='tentar_novamente'>
                        <button className='btn djbtn teste-btn' onClick={()=>setState(states.INIT)}>
                            <p className="btn djbtn">Tentar Novamente</p>
                        </button>
                    </div>)}
                </div>
            </div>
        </div>)
    }

    return (
        <div className="quiz-conteiner">

            {quiz_info_header}

            <div className={`quiz-info`} style={{'backgroundColor':'var(--cor_bloco-testef)'}}>
                <div style={{"height": "10px"}}/>
                <h1>{`Estes são os dados do Teste de Conhecimentos`}</h1>
                <p style={{"margin": "30px","fontSize": "2.1rem"}}>
                    {`*  Você tem: ${total_tentativas-tentativas} do total de ${total_tentativas} tentativas`}</p>
                {tentativas_infos}
            </div>
        </div>
    )
}

function BLoading({texto}){
    return (
    <div className="quiz-conteiner">
        <Loading texto={texto}/>
    </div>
    )
    //<div>{'LOADING...'} </div>
}

function PreStart(props){
    const {setState,setTelaCheia} = props;

    const OnClick_Start = async (event)=>{
        //-dj//console.log('Iniciando quiz')
        //carregarPerguntas()
        setTelaCheia(true);
        setState(states.PRE_START);
    }

    return (
        <div className="quiz-conteiner">
            <div className={`quiz-info`} style={{'backgroundColor':'var(--cor_bloco-testef)'}}>
                <h1>Você tem duas chances de respoder o Teste de Conhecimentos</h1>
                <div style={{"height": "10px"}}/>
                <p> Alcançando 70% de acertos, você receberá o certificado desta missão</p>
            </div>
            <div className={`quiz-info`} style={{'backgroundColor':'var(--cor_bloco-testef)'}}>
                <h1>Informações importantes</h1>
                <p>{`*  O teste final tem 10 perguntas`}</p>
                <p>{`*  Antes de iniciar o Teste, certifique-se que possui uma boa conexão com a internet`}</p>
            </div>

            <button className='btn djbtn teste-btn' onClick={OnClick_Start}>
                <p className="btn djbtn">Iniciar Teste</p>
            </button>
        </div>
    )
}


function Pergunta(props){
    const {
        pergunta,n_pergunta,
        setN_pergunta, setState, setMsg, setAcertos} = props
    //carregarPerguntas()
    const Hc = (pergunta_id,resposta) =>{
        return async (event)=>{

            setState(states.LOADING)
            const validacao = await apiQuizValidar({/*user_id,*/pergunta_id,resposta}).then(
                (data)=>{
                    if (data.success){
                        setMsg(data.messages)
                        setAcertos(resps => {resps.push(data.acertou? "✔" : "❌"); return resps})
                        setState(states.PRE_START)

                        //setState(states.POP_MSG)
                    } else {
                        console.error({pergunta_id, resposta},data);
                        setState(states.ERROR)
                    }
                    return data
                }
            )

            console.log(validacao.messages)

            //window.alert(validacao.messages)

            await setN_pergunta(n=>n+1)
        }
    }
    //const enviar_resposta = ()=>console.alert('não concluiu o quiz')
    return (<form className="quiz-conteiner">
        <div className="quiz" style={{'backgroundColor':'transparent'}}>
            <div className="pergunta-titulo">
                <p>{`${n_pergunta}ª) ${pergunta.titulo}`}</p>
                <p className="pergunta-autor">Autor: {pergunta.autor}</p>
            </div>
            <div className='alternativas'>
            {pergunta.alternativas.map((alternativa,i) => (alternativa.texto!==""&&
                <div className='btn djbtn' key={alternativa.key} >
                    {/*alternativa.texto*/}

                    <input
                        type="button"
                        onClick={Hc(pergunta.id,alternativa.key)}
                        name={alternativa.key}
                        value={alternativa.texto}
                        className="alternativa"/>
                </div>
            ))}
            </div>
            {/*
                <div className='teste-btn' onClick={enviar_resposta}>
                    <p className="btn djbtn">Enviar Respostas</p>
                </div>
            */}
        </div>
    </form>)
}


/******************************************************************************/

async function apiTesteStart({teste_final_id, n_pergunta}){
    const url = '/testef/start/'
    const data = await api.post(url,{
        teste_final_id,n_pergunta
    }).then(res => res.data).catch(e=>{
        return {success:false,mensagens:'Erro de conexão, tente novamente mais tarde'}
    })
    return data
}

async function apiQuizValidar({pergunta_id,resposta}){

    const data = await api.post('/testef/start/validar',{
        pergunta_id,
        resposta,
    }).then(res => res.data).catch(e=>{
        return {success:false,mensagens:'Erro de conexão, tente novamente mais tarde'}
    })
    return data
}

async function apiTesteStartAddu({user_id,teste_final_id,tentativas,n_acertos}){
    const url = '/testef/start/addu'
    const data = await api.post(url,{
        user_id,teste_final_id,tentativas,n_acertos
    }).then(res => res.data).catch(e=>{
        return {success:false,mensagens:'Erro de conexão, tente novamente mais tarde'}
    })
    return data
}

async function apiGet(url){
    const res = await api.get(url).then(res => res.data).catch(e=>{
        return {success:false,mensagens:'Erro de conexão, tente novamente mais tarde'}
    })
    return res
}
function BtnCertificado({teste_final_id}){

    const url = `/testef/${teste_final_id}/certificado/`;
    const {data:certificado} =  useFetch(url);
    // console.log("certificado",certificado)
    return (
    <div className='tentar_novamente'>
        <a href={certificado?.url} className={`btn baixar-btn${!!certificado?.url?' djbtn':'-block'}`} /*onClick={}*/>
            <p className="btn">Baixar Certificado</p>
        </a>
    </div>)
}

//
// const uiicon = {
//     fi_rr_expand:(<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19 24h-2a1 1 0 010-2h2a3 3 0 003-3v-2a1 1 0 012 0v2a5.006 5.006 0 01-5 5zM1 8a1 1 0 01-1-1V5a5.006 5.006 0 015-5h2a1 1 0 010 2H5a3 3 0 00-3 3v2a1 1 0 01-1 1zm6 16H5a5.006 5.006 0 01-5-5v-2a1 1 0 012 0v2a3 3 0 003 3h2a1 1 0 010 2zM23 8a1 1 0 01-1-1V5a3 3 0 00-3-3h-2a1 1 0 010-2h2a5.006 5.006 0 015 5v2a1 1 0 01-1 1z"/></svg>),
//     fi_rr_compress_alt:(<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M7.293 2.091L5.4 3.985 1.707.293A1 1 0 00.293 1.707L3.985 5.4 2.091 7.293A1 1 0 002.8 9h4.764A1.436 1.436 0 009 7.564V2.8a1 1 0 00-1.707-.709zM20.015 18.6l1.894-1.894A1 1 0 0021.2 15h-4.764A1.436 1.436 0 0015 16.436V21.2a1 1 0 001.707.708l1.893-1.893 3.692 3.692a1 1 0 001.414-1.414zM16.436 9H21.2a1 1 0 00.708-1.707L20.015 5.4l3.692-3.692A1 1 0 0022.293.293L18.6 3.985l-1.893-1.894A1 1 0 0015 2.8v4.764A1.436 1.436 0 0016.436 9zm-8.872 6H2.8a1 1 0 00-.708 1.707L3.985 18.6.293 22.293a1 1 0 101.414 1.414L5.4 20.015l1.894 1.894A1 1 0 009 21.2v-4.764A1.436 1.436 0 007.564 15z"/></svg>),
// }
